import colors from 'theme/_colors.scss';

export const chartColors = [
    colors.jacarta,
    colors.citron,
    colors.blueBayoux,
    colors.mariner,
    colors.lightPurple,
    colors.warmGreen,
    colors.teak
];

export const AnomalyLevels = {
    level1: 1,
    level2: 2,
    level3: 3,
    level4: 4,
    level5: 5,
    level0: 0
};

export const CHART_CONDITION_TREND_KPI_TYPE = 'Kpi';
